import React, { useState, useEffect } from 'react';
import { useAppContext } from '../libs/contextLib';
import PropTypes from 'prop-types';
import { getPromiseFromApi } from '../libs/integralLib';
import { Container, Row, Col } from 'react-bootstrap';
import Notification from './Notification';
import config from '../config';

function Notifications({
  ...props
}) {
  const [ notifications, setNotifications ] = useState([]);
  const { userState } = useAppContext();
  const { user }      = useAppContext();

  useEffect(
    () => {
      // get the notifications.
      getPromiseFromApi(
        `${config.api.address}/notifications?active=true`
      )
      .then(({ code, data }) => {
          if (data.hasOwnProperty('data')) {
            setNotifications(data.data);
          }
        }
      ).catch((err) => {
        console.error(`Failed retrieving notifiactions: '${err}'.`)
      })
    },
    [userState, user]
  )

  function getNotifications() {
    return notifications.map(notification => (
        <Notification
          id = { notification.id }
          key = { notification.id }
          type = { notification.type }
          message = { notification.message }
        />
      ));
  }

  return (
    <>
    {
      notifications.length > 0
        ? 
      <Container fluid="sm" className='mt-3'>
        <Row>
          <Col >{ getNotifications() }</Col>
        </Row>
      </Container>
      :
      <></>
    } 
    </>
  )
}

Notifications.propTypes = {
  /**
   * Notification id.
   */
  id: PropTypes.number,
  /**
   * Type of notification, determines how the notification is displayed. One of:
   * 
   * * primary
   * * secondary
   * * success
   * * danger
   * * warning
   * * info
   * * light
   * * dark
   * 
   * Corresponds with types from bootstrap.
   */
   type: PropTypes.string,
   /**
    * Markdown message to display.
    */
   message: PropTypes.string,
 }

export default Notifications;